import { render, staticRenderFns } from "./VolunteerDataOverview.vue?vue&type=template&id=7ca8fbee"
import script from "./VolunteerDataOverview.vue?vue&type=script&lang=js"
export * from "./VolunteerDataOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports